var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"fill-height":""}},[_c('v-col',{attrs:{"cols":_vm.$vuetify.breakpoint.mdAndUp ? 10 : 12,"offset":_vm.$vuetify.breakpoint.mdAndUp ? 1 : 0}},[_c('v-container',[(_vm.showDoc)?_c('DocUser'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }